import { Component } from '@angular/core';
import { filter, map, Observable, switchMap } from 'rxjs';
import { EditableFieldSection } from '../../../models/ui/editable-field-section.model';
import { NotificationManager } from '../../../managers/notification.manager';
import { MatDialog } from '@angular/material/dialog';
import { EditableFieldNode } from '../../../models/ui/editable-field-node.model';
import { tap } from 'rxjs/operators';
import { AccountManager } from '../../../managers/account.manager';
import { AddCaseFieldComponent } from '../../dialogs/add-case-field/add-case-field.component';
import { HelpService } from '@services/help.service';

@Component({
    selector: 'lex-manage-case-fields',
    templateUrl: './manage-case-fields.component.html',
    styleUrls: ['./manage-case-fields.component.scss'],
    standalone: false
})
export class ManageCaseFieldsComponent {
	public fields$: Observable<EditableFieldSection[]>;

	constructor(
		private accountManager: AccountManager,
		private notificationManager: NotificationManager,
		private dialog: MatDialog,
		private helpService: HelpService
	) {
		this.helpService.updateHelpLinkUrl('https://sites.google.com/a/ediscoveryplatform.com/help/home/help/account-menu/case-fields');
		this.fields$ = this.accountManager.editableFieldCollection$.pipe(
			filter((x) => !!x),
			map((x) => x.items)
		);
		this.accountManager.refreshEditableFields();
	}

	public onItemChanged(node: EditableFieldNode | EditableFieldSection): void {
		this.accountManager.saveEditableField({ field: node }).subscribe();
	}

	public onItemDeleted(node: EditableFieldNode | EditableFieldSection): void {
		this.accountManager.removeEditableField({ field: node }).subscribe({
			next: () => {
				this.notificationManager.displaySnackBarMessage({
					message: `Item removed successfully`
				});
				this.accountManager.refreshEditableFields();
			},
			error: (error) => {
				this.notificationManager.displaySnackBarMessage({
					message: error.message,
					type: 'error',
					ttl: 20000
				});
			}
		});
	}

	public onAddItem(): void {
		this.dialog.open(AddCaseFieldComponent, {
			data: {
				fields$: this.fields$
			}
		}).afterClosed().pipe(
			switchMap((x) => {
				if (x?.length > 1) {
					return this.accountManager.createEditableField({ field: x[0] }).pipe(
						switchMap((newSection) => {
							x[1].parentId = newSection.id;
							return this.accountManager.createEditableField({ field: x[1] });
						})
					);
				}
				return this.accountManager.createEditableField({ field: x[0] });
			}),
			tap(() => this.accountManager.refreshEditableFields())
		).subscribe();
	}
}
